(function () {
  function getSelectedSwatchColor() {
    // Try a checked radio swatch label (data-option-type color or swatch_color)
    var label =
      document.querySelector(
        'variant-picker .m-product-option--swatch input[type="radio"]:checked + label[data-option-type="color"],' +
          'variant-picker .m-product-option--swatch input[type="radio"]:checked + label[data-option-type="swatch_color"]',
      ) ||
      document.querySelector(
        'variant-picker .m-product-option--swatch label[data-selected="true"][data-option-type="color"],' +
          'variant-picker .m-product-option--swatch label[data-selected="true"][data-option-type="swatch_color"]',
      );

    if (!label) return null;

    // Dot-on-pill: circle color is the product colour (not the pill bg)
    if (label.classList.contains("has-dot")) {
      return (
        label.style.getPropertyValue("--swatch-dot").trim() ||
        label.style.getPropertyValue("--swatch-background").trim() ||
        null
      );
    }

    if (label.dataset.optionType === "color") {
      return label.style.backgroundColor || null;
    }
    // swatch_color uses a CSS custom property
    return label.style.getPropertyValue("--swatch-background") || null;
  }

  function updateBulletColor() {
    var color = getSelectedSwatchColor();
    if (color) {
      document.documentElement.style.setProperty("--klar-bullet-color", color);
    }
  }

  document.addEventListener("DOMContentLoaded", updateBulletColor);
  document.addEventListener("variant:changed", updateBulletColor);
})();
